(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["equipment-location-calgary"] && !window.DesignMode) return;
  try {
    
    KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  const newsletterForm = document.getElementById('email_signup');
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterSuccess = document.getElementById('newsletter-success');
  const titleNewsletter = document.getElementById('title-newsletter');
  const newsletterRight = document.querySelector('.newsletter-right');

  newsletterForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form submission

    if (!newsletterEmail.validity.valid) {
      newsletterError.style.display = 'block';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
    } else {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'block';
      titleNewsletter.style.display = 'none';
      newsletterRight.style.display = 'none';
      newsletterForm.reset(); // Optional: Reset the form after successful submission
    }
  });

  newsletterEmail.addEventListener('input', function() {
    if (newsletterEmail.validity.valid) {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
      newsletterRight.style.display = 'block';
    } else {
      newsletterRight.style.display = 'block'; // Show the newsletter-right block when email is invalid
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipment-location-edmonton"] && !window.DesignMode) return;
  try {
    
    KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  const newsletterForm = document.getElementById('email_signup');
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterSuccess = document.getElementById('newsletter-success');
  const titleNewsletter = document.getElementById('title-newsletter');
  const newsletterRight = document.querySelector('.newsletter-right');

  newsletterForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form submission

    if (!newsletterEmail.validity.valid) {
      newsletterError.style.display = 'block';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
    } else {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'block';
      titleNewsletter.style.display = 'none';
      newsletterRight.style.display = 'none';
      newsletterForm.reset(); // Optional: Reset the form after successful submission
    }
  });

  newsletterEmail.addEventListener('input', function() {
    if (newsletterEmail.validity.valid) {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
      newsletterRight.style.display = 'block';
    } else {
      newsletterRight.style.display = 'block'; // Show the newsletter-right block when email is invalid
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipment-location-hamilton"] && !window.DesignMode) return;
  try {
    
    KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  const newsletterForm = document.getElementById('email_signup');
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterSuccess = document.getElementById('newsletter-success');
  const titleNewsletter = document.getElementById('title-newsletter');
  const newsletterRight = document.querySelector('.newsletter-right');

  newsletterForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form submission

    if (!newsletterEmail.validity.valid) {
      newsletterError.style.display = 'block';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
    } else {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'block';
      titleNewsletter.style.display = 'none';
      newsletterRight.style.display = 'none';
      newsletterForm.reset(); // Optional: Reset the form after successful submission
    }
  });

  newsletterEmail.addEventListener('input', function() {
    if (newsletterEmail.validity.valid) {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
      newsletterRight.style.display = 'block';
    } else {
      newsletterRight.style.display = 'block'; // Show the newsletter-right block when email is invalid
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipment-location-moncton"] && !window.DesignMode) return;
  try {
    
    KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  const newsletterForm = document.getElementById('email_signup');
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterSuccess = document.getElementById('newsletter-success');
  const titleNewsletter = document.getElementById('title-newsletter');
  const newsletterRight = document.querySelector('.newsletter-right');

  newsletterForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form submission

    if (!newsletterEmail.validity.valid) {
      newsletterError.style.display = 'block';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
    } else {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'block';
      titleNewsletter.style.display = 'none';
      newsletterRight.style.display = 'none';
      newsletterForm.reset(); // Optional: Reset the form after successful submission
    }
  });

  newsletterEmail.addEventListener('input', function() {
    if (newsletterEmail.validity.valid) {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
      newsletterRight.style.display = 'block';
    } else {
      newsletterRight.style.display = 'block'; // Show the newsletter-right block when email is invalid
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipment-location-vancouver"] && !window.DesignMode) return;
  try {
    
    KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  const newsletterForm = document.getElementById('email_signup');
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterSuccess = document.getElementById('newsletter-success');
  const titleNewsletter = document.getElementById('title-newsletter');
  const newsletterRight = document.querySelector('.newsletter-right');

  newsletterForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form submission

    if (!newsletterEmail.validity.valid) {
      newsletterError.style.display = 'block';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
    } else {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'block';
      titleNewsletter.style.display = 'none';
      newsletterRight.style.display = 'none';
      newsletterForm.reset(); // Optional: Reset the form after successful submission
    }
  });

  newsletterEmail.addEventListener('input', function() {
    if (newsletterEmail.validity.valid) {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
      newsletterRight.style.display = 'block';
    } else {
      newsletterRight.style.display = 'block'; // Show the newsletter-right block when email is invalid
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equipment-location-winnipeg"] && !window.DesignMode) return;
  try {
    
    KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  const newsletterForm = document.getElementById('email_signup');
  const newsletterEmail = document.getElementById('newsletter-email');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterSuccess = document.getElementById('newsletter-success');
  const titleNewsletter = document.getElementById('title-newsletter');
  const newsletterRight = document.querySelector('.newsletter-right');

  newsletterForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent form submission

    if (!newsletterEmail.validity.valid) {
      newsletterError.style.display = 'block';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
    } else {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'block';
      titleNewsletter.style.display = 'none';
      newsletterRight.style.display = 'none';
      newsletterForm.reset(); // Optional: Reset the form after successful submission
    }
  });

  newsletterEmail.addEventListener('input', function() {
    if (newsletterEmail.validity.valid) {
      newsletterError.style.display = 'none';
      newsletterSuccess.style.display = 'none';
      titleNewsletter.style.display = 'block';
      newsletterRight.style.display = 'block';
    } else {
      newsletterRight.style.display = 'block'; // Show the newsletter-right block when email is invalid
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hospitality-insurance"] && !window.DesignMode) return;
  try {
    
  // JavaScript
  document.addEventListener('DOMContentLoaded', function () {
    const contentText = document.getElementById('content-text');
    const boxInfos = document.querySelectorAll('.box-info');
    let currentContent = 'box1'; // Default content
    let hoveredBox = null; // Reference to the currently hovered box

    // Define the content for each option
    const contentMap = {
      box1: "With our two-tier plan design, owners can now write off all expenses eligible through the CRA. Owners can also access private medical and front of the line specialists through our partnership with Cleveland Clinic.",
      box2: "Our multi-tier plan design enables the company to provide benefits to all employees, including part-time employees, while providing a structure that other plans don’t have to control costs. With the exclusive Nella Hospitality Insurance employee benefits pool, you will be part of a pool with thousands of employees. Which means you will be insulated from fluctuations in your individual plan performance.",
      box3: "As employees, we make it simple to understand your benefits and submit claims.",
      box4: "Our 24/7 tele-health benefit helps to avoid hours in the emergency room. Through the 24/7 health application, you can access doctors and nurse practitioners from your living room for many of your non-emergency conditions. Prescriptions are sent directly to the nearest pharmacy."
    };

    // Set the default content to Option 1
    contentText.textContent = contentMap[currentContent];

    // Function to update content and box shadow
    function updateContentAndShadow(boxInfo) {
      const contentKey = boxInfo.getAttribute('data-content');
      currentContent = contentKey;
      const newText = contentMap[contentKey];
      contentText.textContent = newText;

      // Remove box shadow from all boxes
      boxInfos.forEach(function (box) {
        box.style.boxShadow = 'none';
      });

      // Apply box shadow to the hovered/selected box
      boxInfo.style.boxShadow = '0 0 10px #205488';
    }

    // Add event listeners to all box-info elements
    boxInfos.forEach(function (boxInfo) {
      boxInfo.addEventListener('mouseenter', function () {
        if (boxInfo !== hoveredBox) {
          // Reset the previously hovered box on a new hover
          if (hoveredBox !== null) {
            hoveredBox.style.boxShadow = 'none';
          }
          updateContentAndShadow(boxInfo);
          hoveredBox = boxInfo; // Set the currently hovered box
        }
      });

      boxInfo.addEventListener('mouseleave', function () {
        if (boxInfo !== hoveredBox) {
          // Reset the content to the currently selected content on mouse leave
          const newText = contentMap[currentContent];
          contentText.textContent = newText;
          if (hoveredBox !== null) {
            hoveredBox.style.boxShadow = 'none'; // Remove shadow when leaving the box
          }
        }
      });

      boxInfo.addEventListener('click', function () {
        if (hoveredBox !== null) {
          hoveredBox.style.boxShadow = 'none'; // Remove shadow from previously hovered box on click
        }
        updateContentAndShadow(boxInfo);
        hoveredBox = boxInfo; // Set the currently clicked box
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
